import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ArrowDownIcon from 'dibs-vg/dist/react/arrow-down';
import CheckmarkIcon from 'dibs-vg/dist/react/checkmark';

import style from '../Selector-style.scss';

const CountryOptionItem = ({ country, link, onClick, isSelected }) => (
    <li>
        <span
            onClick={onClick}
            className={style.option}
            data-country={country}
            data-link={link}
            data-tn={`footer-country-dropdown-item-${country}`}
        >
            {isSelected ? <CheckmarkIcon className={style.checkmark} /> : null}
            <span className={style.optionLabel}>{country}</span>
        </span>
    </li>
);

class CountryDropdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isExpanded: false,
        };

        this.handleSelectorClick = this.handleSelectorClick.bind(this);
        this.handleOptionClick = this.handleOptionClick.bind(this);
        this.closeDropdown = this.closeDropdown.bind(this);
    }

    componentDidMount() {
        window.addEventListener('click', this.closeDropdown);
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.closeDropdown);
    }

    openDropdown() {
        this.setState({ isExpanded: true });
    }

    closeDropdown() {
        this.setState({ isExpanded: false });
    }

    handleSelectorClick(event) {
        event.stopPropagation();
        this.openDropdown();
    }

    handleOptionClick(event) {
        event.preventDefault();
        event.stopPropagation();

        const linkToRedirect = event.currentTarget.getAttribute('data-link');
        this.props.onChange(linkToRedirect);
        this.closeDropdown();
    }

    render() {
        return (
            <div className={style.selector}>
                <div className={style.label}>
                    <FormattedMessage
                        id="dbl.Footer.CountryDropdown.label"
                        defaultMessage="Country"
                    />
                </div>
                <div
                    data-tn="footer-country-dropdown"
                    className={style.value}
                    onClick={this.handleSelectorClick}
                >
                    {this.props.country}
                    <ArrowDownIcon className={style.arrow} />
                    {this.state.isExpanded ? (
                        <ul className={style.dropdownCountrySelector}>
                            {this.props.countries.map(({ country, link }) => {
                                const isSelected = this.props.country === country;
                                return (
                                    <CountryOptionItem
                                        key={country}
                                        onClick={this.handleOptionClick}
                                        country={country}
                                        link={link}
                                        isSelected={isSelected}
                                    />
                                );
                            })}
                        </ul>
                    ) : null}
                </div>
            </div>
        );
    }
}

CountryDropdown.propTypes = {
    countries: PropTypes.arrayOf(PropTypes.object).isRequired,
    country: PropTypes.string.isRequired,
    onChange: PropTypes.func,
};

CountryOptionItem.propTypes = {
    country: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    isSelected: PropTypes.bool.isRequired,
};

CountryDropdown.defaultProps = {
    onChange: () => {},
};

export default CountryDropdown;
